<form lin-layout-form [formGroup]="form" (ngSubmit)="isContractMode ? updateDevicesContract() : updateDevicesOwnership()">
  <span class="info">{{ 'ADMIN.DEVICES.SELECTED_DEVICES' | translate: { value: devicesCount } }}</span>

  @if (isContractMode) {
  <lin-form-label>{{ 'FIELDS.contractId' | translate }}:</lin-form-label>
  <mat-form-field>
    <input matInput formControlName="contractId" />
    <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
  </mat-form-field>

  <lin-form-label>{{ 'FIELDS.contractStartAt' | translate }}:</lin-form-label>
  <lin-datepicker-field formControlName="contractStartAt" [isNoMaxDate]="true"></lin-datepicker-field>

  <lin-form-label>{{ 'FIELDS.contractFinishAt' | translate }}:</lin-form-label>
  <lin-datepicker-field formControlName="contractFinishAt" [isNoMaxDate]="true"></lin-datepicker-field>
  } @else {
  <lin-form-label>{{ 'FIELDS.ownership' | translate }}:</lin-form-label>
  <mat-form-field>
    <mat-select formControlName="ownership">
      @for (ownership of DeviceOwnershipLabel | keys; track ownership) {
      <mat-option [value]="ownership">{{ DeviceOwnershipLabel[ownership] | translate }}</mat-option>
      }
    </mat-select>
    <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
  </mat-form-field>
  }

  <lin-form-submit-button [isLoading]="isSubmitting" data-testid="btn-dialog-confirm"
    >{{ 'BUTTONS.SUBMIT' | translate }}</lin-form-submit-button
  >
</form>
